class LqdPromoHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initCustomAnimation();
    this.initReveal();

  }

  getDefaultSettings() {
    return {
      isotopeData: null,
      selectors: {
        customAnimationElement: '[data-custom-animations]',
        revealElement: '[data-reveal]',
        splitTextElement: '[data-split-text]',
        dynamicShapeElement: '[data-dynamic-shape]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $revealElement: this.$element.find(selectors.revealElement),
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $dynamicShapeElement: this.$element.find(selectors.dynamicShapeElement),
    }
  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initReveal() {

    this.elements.$revealElement.liquidReveal();

  }
  
  initDynamicShape() {

    this.elements.$dynamicShapeElement.liquidDynamicShape();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleCustomAnimationDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdPromoHandler, { $element } );
};